<template>
  <div aria-live="assertive"
       class="space-y-3 z-10 fixed inset-0 px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
    <div v-for="user in users" :key="user.id" class="w-full flex flex-col items-center space-y-4">
      <transition enter-active-class="transform ease-out duration-300 transition"
                  enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                  enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                  leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                  leave-to-class="opacity-0">
        <MemberNotification :user="user" @reject="handleReject($event)"
                            @approve="handleApprove($event)"></MemberNotification>
      </transition>
    </div>
  </div>

</template>

<script>
import MemberNotification from "@/Pages/Lobby/Components/MemberNotification";
import {message} from "ant-design-vue";
export default {
  components: {
    MemberNotification,
    message
  },
  props: {
    title: {
      type: String,
      default: 'Waiting in lobby'
    },
    users: {
      type: Array,
      default: [],
    },
    room: {
      default: {
        'room_key': '',
        'room_id': '',
        'room_name': '',
        'team_owner_name': '',
        'room_type': '',
        'team_id': '',
        'team_owner_id': '',
        'is_public': false,
      }
    }
  },
  setup(props) {


    const handleApprove = async (user) => {

      await axios.post(route("lobby.approve.user", {id: user.id}),
          {
            type: props.room.room_type,
            room_key: props.room.room_key
          })
          .then((response) => {
            if(response.data.success){
              message.success('User has been approved')
            }else{
              message.error(response.data.message, 9999)
            }
          })
          .catch((error) => {
            console.log(error);
            message.error('Something went wrong', 5);
          })

    };

    const handleReject = async (user) => {

      await axios.post(route("lobby.reject.user", {id: user.id}),
          {
            type: props.room.room_type,
            room_key: props.room.room_key
          })
          .then((response) => {
            message.success('User has been rejected')
          })
          .catch((error) => {
            console.log(error);
            message.error('Something went wrong', 5);
          })

    };
    return {
      handleApprove,
      handleReject
    }
  },
}
</script>